
























































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import * as api from '@/api/business-overview';

import parkingOverview from './components/parking-overview.vue';
import incomeOverview from './components/income-overview.vue';
import todayDischarge from './components/today-discharge.vue';
import incomeStatistics from './components/income-statistics.vue';
import abnormalStatistics from './components/abnormal-statistics.vue';
import paymentStatistics from './components/payment-statistics.vue';
import parkingCount from './components/parking-count.vue';
import deviceOnline from './components/device-online.vue';
import fastLink from './components/fast-link.vue';
import viewModelDebugMixin from '@root/common/mixins/viewmodel-debug';

const STATUS = {
  '00': '离线',
  '01': '在线',
  '02': '未接入'
};

@Component({
  name: 'BusinessOverview',
  components: {
    parkingOverview,
    incomeOverview,
    todayDischarge,
    incomeStatistics,
    abnormalStatistics,
    paymentStatistics,
    parkingCount,
    deviceOnline,
    fastLink
  }
})
export default class BusinessOverview extends Vue {
  // 0,集团，1，单项目
  type: number = null;

  // 集团
  orgDepId: String = '';
  orgIds: Array<String> = [];
  provinceId: String = '';
  // 单项目
  parkId: String = '';
  parkName: String = '';
  parkStatus: String = '';

  overviewData: any = null;

  @Watch('orgDepId')
  onOrgDepIdChange() {
    const orgDepId = this.orgDepId;
    const allOrgIds = [];
    function getOrgChildren(list) {
      for (const child of list) {
        if (child.children && child.children.length) {
          getOrgChildren(child.children);
        }
        if (child.type === 'org') {
          allOrgIds.push(child.id);
        }
      }
    }
    function findOrg(list) {
      for (const node of list) {
        if (node.id === orgDepId) {
          allOrgIds.push(node.id);
          if (node.children) {
            getOrgChildren(node.children);
          }
          return;
        } else if (node.children && node.children.length) {
          findOrg(node.children);
        }
      }
    }

    findOrg(this.getUserOrgTree);
    this.orgIds = allOrgIds;
  }

  @Watch('type')
  @Watch('orgIds')
  @Watch('provinceId')
  onChangeValue(newValue: string | null) {
    this.fetchData();
  }

  @Watch('parkList')
  onParkListChange() {
    if (this.parkList.length === 1) {
      this.type = 1;
      this.parkId = this.parkList[0].id;
      this.parkName = this.parkList[0].name;
    } else if (this.parkList.length > 1) {
      this.type = 0;
    }
  }

  @Getter('organizations/getUserOrgTree')
  getUserOrgTree!: any[];

  @Getter('organizations/getUserParkingList')
  parkList!: any[];

  // @Watch('getUserOrgTree')
  // onGetUserOrgTree() {
  //
  // }

  async fetchData() {
    try {
      if (this.type == 0) {
        const { status, msg, code, data } = await api.queryParkingOverviewData({
          orgIds: this.orgIds,
          provinceId: this.provinceId
        });
        this.overviewData = data;
      } else if (this.type == 1) {
        const { status, msg, code, data } = await api.querySingleParkingOverviewData({
          parkId: this.parkId
        });
        this.overviewData = data;
        this.parkStatus = STATUS[this.overviewData.connectStatus];
      }
    } catch (e) {
      console.log(e);
    }
  }

  mounted() {
    this.onParkListChange();
    this.fetchData();
  }
}
